// extracted by mini-css-extract-plugin
export default {"avatar_container":"UserAvatar_avatar_container__2cGIT"};